import './index.css';
import ModalWeb from 'modal-react-native-web';
import { Picker } from 'react-native';
import Draggable from 'react-draggable';

import { PublicKey, Connection, clusterApiUrl, Keypair } from '@solana/web3.js';
import { encodeURL, findReference } from '@solana/pay';

// TODO: cant find solution to ignore this import in rn packager
import '../../node_modules/npm-font-open-sans/open-sans.css';

// import iconFont from '../../src/assets/fonts/icons.ttf';

// window.iconFont = iconFont;
window.ModalWeb = ModalWeb;
window.Picker = Picker;
window.Draggable = Draggable;

window.SOL = {
  PublicKey, Connection, clusterApiUrl,
  encodeURL, findReference, Keypair,
};

// Capture invite link param for new-warrior linkage.
try {
  const params = new URLSearchParams(window.location.search);
  const invitedBy = params.get('invitedBy');
  if (invitedBy) {
    window.localStorage.setItem('invitedBy', invitedBy);
    params.delete('invitedBy');
    const newSearch = params.toString();
    const newUrl =
      window.location.pathname + (newSearch ? `?${newSearch}` : '') + window.location.hash;
    window.history.replaceState({}, '', newUrl);
  }
} catch (e) {
  // ignore — non-critical
}

require('../../App');
